import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/styled-system'
import { textStyleKeys } from '~/themes/textStyles'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

import { contactsColorKeys } from './_colors'

const ContactsDetailViewColors = contactsColorKeys.Contacts.ContactsDetailView

const ContactItemsParts = ['container', 'text', 'scrollContainer'] as const

const helpers = createMultiStyleConfigHelpers(ContactItemsParts)

export const ContactItemsStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      flexDirection: 'column',
      height: { base: 'fit-content', sm: 'auto' },
      backgroundColor: ContactsDetailViewColors.OuterContainer.BackgroundColor,
      flex: '1 0 0',
      paddingX: '1.75rem',
      paddingTop: '2.5rem',
      paddingBottom: '1.25rem',
      borderRadius: '0.5rem',
      border: '2px solid',
      borderColor: ContactsDetailViewColors.OuterContainer.BorderColor,
    },
    text: {
      width: 'full',
      paddingBottom: '0.75rem',
      borderBottom: '1px solid',
      borderColor: ContactsDetailViewColors.InnerContainer.BorderColor,
      textStyle: textStyleKeys.Body2_Bold,
    },
    scrollContainer: {
      overflowY: { base: 'visible', sm: 'scroll' },
    },
  },
})

export const useContactItemsStyle = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof ContactItemsParts>(
    getName({ ContactItemsStyle }),
    props,
  )
}
